module.exports = __webpack_public_path__ + "img/adaptations2.72d161d1.png";